<template>
  <base-dialog :show-close="true" :visible.sync="visible" class="add-url-dialog" width="520px">
    <template v-slot:header>{{ operation }}</template>
    <div class="main-content">
      <el-form :rules="rules" :model="form" label-width="100px" ref="form">
        <el-form-item prop="name" label="链接名称">
          <el-input placeholder="请输入链接名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="设计图标" required class="design-icon">
          <span class="icon-info">
            <svg-icon :style="'color:' + form.color" :icon-class="'sheet_' + form.icon"></svg-icon>
          </span>
          <design-icon-popper
            style="margin: 4px 8px;"
            :colors="boardColors"
            :icons="boardIcons"
            :cur-data="form"
            from="sheet"
            @changeData="changeFormInfo"
          ></design-icon-popper>
        </el-form-item>
        <el-form-item prop="url" label="跳转链接">
          <el-input placeholder="请输入跳转链接" v-model="form.url"></el-input>
          <el-checkbox v-model="form.newTag">在新标签页打开</el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import DesignIconPopper from "@/components/BaseComponents/DesignIconPopper"
import { boardColors, boardIcons } from "@/views/Backend/Admin/Statistics/static"
import { checkUrl } from "@/views/Backend/Admin/Display/Menu/validate"

export default {
  name: "AddUrlDialog",
  components: { DesignIconPopper, BaseButton, BaseDialog },
  data() {
    return {
      boardColors,
      boardIcons,
      visible: false,
      form: {
        name: "",
        icon: "icon-33",
        color: "#BA67FF",
        url: "",
        type: "URL",
        newTag: true
      },
      rules: {
        name: [{ required: true, message: "请输入看板名称", trigger: "blur" }],
        url: [
          { required: true, message: "请输入跳转链接", trigger: "blur" },
          { validator: checkUrl, trigger: "blur" }
        ]
      },
      operation: "添加链接"
    }
  },
  methods: {
    open(url) {
      this.form = url ? url : this.$options.data().form
      this.operation = url ? "编辑链接" : "添加链接"
      this.visible = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit("submit", this.form)
          this.visible = false
        } else {
          return false
        }
      })
    },
    changeFormInfo(key, val) {
      this.$set(this.form, key, val)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-url-dialog {
  .design-icon {
    .icon-info {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      font-size: 20px;
      border: 1px solid #dcdfe6;
      border-radius: 6px;
    }
    ::v-deep {
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 20px 40px;
      color: unset;
    }
  }
}
</style>
